import script from "./UploadFileForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFileForm.vue?vue&type=script&setup=true&lang=js"

import "./UploadFileForm.vue?vue&type=style&index=0&id=19f6515f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19f6515f"]])

export default __exports__